document.addEventListener('DOMContentLoaded', function () {
  var grids = document.querySelectorAll('.bss-product-grid');

  grids.forEach(function (grid) {
    var wrappers = grid.querySelectorAll('.bss-card-wrapper[data-bbs-sale="true"]');
    wrappers.forEach(function (wrapper) {
      var links = wrapper.querySelectorAll('a[href*="/products/"]');
      links.forEach(function (link) {
        var url = new URL(link.href, window.location.origin);
        if (!url.searchParams.has('view')) {
          url.searchParams.set('view', 'birthday-bash-sale');
          link.href = url.toString();
        }
      });
    });
  });
});
